// @ts-nocheck
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "@/lib/trpc";
import { formatMoney } from "@/lib/utils";

export function CustomerDebtDisplay({ customerId }: { customerId: string }) {
  const { data: customer, isLoading } = useQuery(
    trpc.customers.getById.queryOptions(
      { id: customerId },
      { enabled: !!customerId }
    )
  );

  if (!customerId) return null;
  if (isLoading) return <div className="text-sm text-slate-500">Đang tải công nợ...</div>;
  if (!customer) return null;

  const initialDebt = Number(customer.computedOpeningDebt ?? customer.initialDebt) || 0;
  const orderValue = Number(customer.orderValue) || 0;
  const collected = Number(customer.paidInPeriod) || 0;
  const currentDebt = initialDebt + orderValue - collected;

  return (
    <div className="bg-amber-50/50 border border-amber-200 rounded-lg p-4 flex items-center">
      <span className="font-semibold text-slate-800 text-sm">Nợ phải thu:</span>
      <span className="ml-2 font-bold text-red-500 text-base">
        {formatMoney(currentDebt)}
      </span>
      <span className="text-slate-500 ml-2 text-xs">({customer.name})</span>
    </div>
  );
}
